import React from 'react';
import { Modal, ModalFooter, ModalBody, ModalHeader, Button } from 'reactstrap';
import FacultyList from './FacultyList';
import { getOptions } from '../../utils';

class FacultySearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedPersonIds: [],
            selectedPersonnelType: 'POC'
        };
    }
    handleAdd = () => {
        this.props.onAdd(this.state.selectedPersonIds);
    }

    handleSelectionChanged = (selectedPersonIds) => {
        this.setState({ selectedPersonIds });
    }

    handlePersonnelTypeChange = (e) => {
        this.setState({ selectedPersonnelType: e.currentTarget.value });
    }
    render() {
        return (
            <Modal
                scrollable={true}
                isOpen={this.props.isOpen}
                toggle={this.props.toggle}
                size='lg'
            >
                <ModalHeader toggle={this.props.toggle}>Faculty Search
                </ModalHeader>
                <ModalBody>
                    <FacultyList
                        data={this.props.data}
                        onSelect={this.handleSelectionChanged}
                        rowSelection={this.state.selectedPersonnelType === 'POC' ? 'single' : 'multiple'}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" disabled={this.state.selectedPersonIds.length > 0 ? false : true} onClick={this.handleAdd}>Add</Button>{' '}
                    <Button color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default FacultySearch